import axios from "../../axiosConfig";
import { call, put } from "redux-saga/effects";
import { ADD_NEW_C_TARGETING_FAILED, ADD_NEW_C_TARGETING_SUCCESS,GET_C_TARGETING_LIST_SUCCESS,GET_C_TARGETING_LIST_FAILED, GET_C_TARGETING_LIST_REQUEST,GET_C_TARGETING_SEGMENTS_SUCCESS,GET_C_TARGETING_SEGMENTS_FAILED } from "../Actions/CtargetingActions";
import { TOAST_SHOW } from "../Actions/ToastAction";

export function* AddNewCTargeting(action:any):unknown{
    try {
        const response = yield call(axios.post,'cTarget',action.payload,{
            headers: { "Content-Type": "multipart/form-data" },
          });
        const { 
            //data,
            status
        } = response
        if(status ===200){
            yield put({type:ADD_NEW_C_TARGETING_SUCCESS})
            yield put({type:GET_C_TARGETING_LIST_REQUEST})
            yield put({type:TOAST_SHOW,payload:{ message: 'C-Targeting added successfully', severity: 'Success', show: true }})
        }
    } catch (error) {
        yield put({type:ADD_NEW_C_TARGETING_FAILED})
        yield put({
            type: TOAST_SHOW,
            payload: { message: 'Something went wrong!', severity: 'Danger', show: true },
        });
    }
}

export function* GetCTargetingList(action: any): unknown {
  try {
    const response = yield call(axios.get, "cTarget");

    const { data, status } = response;

    if (status === 200) {
       yield put({
        type: GET_C_TARGETING_LIST_SUCCESS,
        payload: data,
      });
    } else {
        yield put({type:GET_C_TARGETING_LIST_FAILED})
        yield put({
            type: TOAST_SHOW,
            payload: { message: 'Something went wrong!', severity: 'Danger', show: true },
        });
    }
  } catch (e) {
    yield put({type:GET_C_TARGETING_LIST_FAILED})
    yield put({
        type: TOAST_SHOW,
        payload: { message: 'Something went wrong!', severity: 'Danger', show: true },
    });
  }
}


export function* GetCTargetingSegments(action: any): unknown {
    try {
      const response = yield call(axios.get, "cTargetSegments");
  
      const { data, status } = response;
  
      if (status === 200) {
         yield put({
          type: GET_C_TARGETING_SEGMENTS_SUCCESS,
          payload: data,
        });
      } else {
          yield put({type:GET_C_TARGETING_SEGMENTS_FAILED})
          yield put({
              type: TOAST_SHOW,
              payload: { message: 'Something went wrong!', severity: 'Danger', show: true },
          });
      }
    } catch (e) {
      yield put({type:GET_C_TARGETING_SEGMENTS_FAILED})
      yield put({
          type: TOAST_SHOW,
          payload: { message: 'Something went wrong!', severity: 'Danger', show: true },
      });
    }
  }
